import React, {useCallback, useEffect, useState, useRef} from "react";
import PropTypes from 'prop-types';
import axios from "axios";
import { format } from "date-fns";
import { Translate } from "../Translator";
import DatasourceBaseOauthNew from "../Datasources/DatasourceBaseOauthNew.jsx";
import { ConfigurationApiDatasourceInfo } from "../../ExternalApi/ConfigurationApi"

const DatasourceExactOnlineNew = (props) => {

    const [mServers, SetServers] = useState([])  
    const [mSelectedServerIndex, SetSelectedServerIndex] = useState(-1) 
        
    const [mAuthUrl, SetAuthUrl] = useState("")  
    const [mClientId, SetClientId] = useState("")  

    const [mDivisions, SetDivisions] = useState([]) 
    const [mSettingDivisions, SetSettingDivisions] = useState([]) 

    useEffect(() => {

        async function GetServers() {
            console.log("GetServers")
            try 
            {
                const result = await axios.get(
                    "https://integration-va.cloudcti.nl/crm2025/api/exactonline/servers"
                )
                console.log("Request ok",result)

                return result.data   
            } 
            catch (error) 
            {
                console.log("Request failed", error)
                return false
            }
        }
  
        async function Initialize() {  

            const Servers = await GetServers()
            SetServers(Servers) 

            if (Servers.length > 0)
            {
                SetSelectedServer(0,Servers)
            }
        }
  
        Initialize()
    }, []);

    function SetSelectedServer(aSelectedServerIndex, aServers)
    {
        //Clear settings
        SetDivisions([])
        props.IntegrationSettings.DatasourceSettings = {}

        //Initialize
        const Server = aServers[aSelectedServerIndex]

        SetAuthUrl(Server.ServerUrl + "/api/oauth2/auth" +
            "?client_id=" + Server.ClientId + 
            "&redirect_uri=" + "https%3A%2F%2Fauth.cloudcti.nl%2Fwebapi%2Foauth2" +
            "&scope=organization.administration" + 
            "&response_type=code")
        SetClientId(Server.ClientId)

        props.IntegrationSettings.DatasourceSettings.ServerUrl = Server.ServerUrl
        SetSelectedServerIndex(aSelectedServerIndex)
    }

    async function OAuthPollResult(aResponseUrl)
    {
        props.IntegrationSettings.DatasourceSettings.ClientId = mClientId
    }

    async function OAuthGetTokenDone()
    {
        const DateNow = new Date()
        const DateExpires = new Date(DateNow.getTime() + 10 * 60 * 1000)
        props.IntegrationSettings.DatasourceSettings.AccessTokenExpires = DateExpires.toISOString()

        try 
        {
            const result = await ConfigurationApiDatasourceInfo(props.SecurityToken, props.IntegrationSettings.DatasourceType, "Divisions", props.IntegrationSettings.DatasourceSettings)
            console.log("GetInfo divisions returned", result)
            if (result.status === 200)
            {
                SetSettingDivisions(result.data.Info) //Select all by default
                props.IntegrationSettings.DatasourceSettings.Divisions = SettingsDivisionsCommaText(result.data.Info) 
                SetDivisions(result.data.Info)
            }        
        } 
        catch (ex) 
        {    
            console.log("OAuthGetTokenDone GetInfoError",ex)
            return
        }
        
        props.OnSetReady(aFlag)
    }

    async function OAuthComplete(aFlag)
    {
        props.OnSetReady(aFlag)
    }

    function SettingsDivisionsCommaText(aDivisions)
    {
        let Result = ""
        aDivisions.map(division => (Result === "" ? Result = Result + division.Division : Result = Result + "," + division.Division))
        return Result
    }

    function SettingsHasDivision(aDivision)
    {
        return mSettingDivisions.filter(division => (division.Name === aDivision.Name) && (division.Division === aDivision.Division)).length > 0
    }

    function SettingsUpdateDivisions(aFlag, aDivision)
    {
        if (!aFlag)
        {
            const Divisions = mSettingDivisions.filter(division => (division.Name !== aDivision.Name) || (division.Division !== aDivision.Division))
            SetSettingDivisions(Divisions)
            props.IntegrationSettings.DatasourceSettings.Divisions = SettingsDivisionsCommaText(Divisions)
        }
        else if (!SettingsHasDivision(aDivision))
        {
            const Divisions = [...mSettingDivisions, aDivision]
            SetSettingDivisions(Divisions)
            props.IntegrationSettings.DatasourceSettings.Divisions = SettingsDivisionsCommaText(Divisions)
        }
    }

    return mServers.length > 0 ?
        <div className="scriptitembody">
            <div className="wizardfieldname">{Translate("Region").toUpperCase()} <span className="redtext">*</span></div>
            <div className="wizardfieldvalue">
                <select name="Region" value={mSelectedServerIndex} onChange={evt => SetSelectedServer(evt.target.value, mServers)} className="wizardinputfield">
                    {mServers.map((server, index) => <option key={"server" + index} value={index}>{server.Country}</option>)}
                </select>
            </div>

            <DatasourceBaseOauthNew SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} AuthUrl={mAuthUrl} CrmServerTokenController="/api/exactonline/tokens" OnOAuthPollResult={OAuthPollResult} OnOAuthGetTokenDone={OAuthGetTokenDone} OnSetReady={OAuthComplete}/>

            <table cellPadding="2">
            <tbody>
                {mDivisions.map((division, index) => 
                    <tr key={"division" + index}>
                        <td width="30"><span className="checkbox-wrapper-13"><input type="checkbox" checked={SettingsHasDivision(division) ? "checked" : ""} value={division} onChange={evt => SettingsUpdateDivisions(evt.target.checked, division)}/></span></td>
                        <td width="*">{division.Name}</td>
                    </tr>)}
            </tbody>
            </table>
        </div> :
        <div>Waiting...</div>
}

DatasourceExactOnlineNew.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceExactOnlineNew